export default "__VITE_ASSET__CU6Y1wSr__"